import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { RequestResponse } from '../intefaces/requestResponse';

@Injectable({
  providedIn: 'root'
})
export class CategoryService extends BaseService {
  constructor(protected http: HttpClient) {
    super();
  }

  public addCategory(category) {
    return this.http.post<RequestResponse>(this.getUrl('addCategory'), category);
  }
  public editCategory(category) {
    return this.http.post<RequestResponse>(this.getUrl('editCategory'), category);
  }
  public getCategories(object = null) {
    return this.http.post<RequestResponse>(this.getUrl('getCategories'), object);
  }
  public getNotesByCategoryId(category) {
    return this.http.post<RequestResponse>(this.getUrl('getNotesByCategoryId'), category).pipe();
  }
  public copyOrMoveNoteCategory(object) {
    return this.http.post<RequestResponse>(this.getUrl('copyOrMoveNoteCategory'), object).pipe();
  }
  public deleteNoteFromCategory(object) {
    return this.http.post<RequestResponse>(this.getUrl('deleteNoteFromCategory'), object).pipe();
  }

  public removeCategory(object) {
    return this.http.post<RequestResponse>(this.setUrl('deleteCategory'), object).pipe();
  }

  public resetCategory(object) {
    return this.http.post<RequestResponse>(this.setUrl('resetCategory'), object).pipe();
  }


  
}
